import classNames from "classnames";
import React, { useContext } from "react";
import { RicosNodeContext, RicosNodeContextProvider } from "./../../ricos-context";
import { TABLE_PLUGIN_CELL } from "../data-hooks";
import styles from "../statics/styles/cell-scss";
import CellBorders from "./CellBorders";
const TableCell = ({ node, nodeIndex, RicosNodesRenderer }) => {
  const { parentNode, parentIndex } = useContext(RicosNodeContext);
  const { borderColors, cellStyle } = node?.tableCellData || {};
  const isHeaderCell = parentIndex === 0 && parentNode?.tableData?.rowHeader || nodeIndex === 0 && parentNode?.tableData?.columnHeader;
  const Tag = isHeaderCell ? "th" : "td";
  const style = {};
  cellStyle?.backgroundColor && (style.backgroundColor = cellStyle.backgroundColor);
  cellStyle?.verticalAlignment && (style.verticalAlign = cellStyle.verticalAlignment.toLowerCase());
  return /* @__PURE__ */ React.createElement(
    Tag,
    {
      "data-hook": TABLE_PLUGIN_CELL,
      className: classNames(styles.cell, isHeaderCell && styles.header),
      style
    },
    /* @__PURE__ */ React.createElement("div", { className: classNames(styles.editor, styles.view) }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: node.nodes ?? [], shouldParagraphApplyTextStyle: true }))),
    CellBorders({ borders: borderColors })
  );
};
const TableCellRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(TableCell, { key: node.id, node, ...props });
};
var tableCell_default = TableCellRenderer;
export {
  tableCell_default as default
};
//# sourceMappingURL=tableCell.js.map

import "@wix/ricos/css/plugin-table-viewer.global.css";